export const createBalloonLayout = () => {
	const balloonLayout = ymaps.templateLayoutFactory.createClass(
		'<div class="popup"><div class="arrow"></div><div class="content">$[properties.balloonContent]</div></div>',
		{
			build: function () {
				this.constructor.superclass.build.call(this);

				this.setBalloonProperties();
			},
			setBalloonProperties: function () {
				this.properties = {};
				this.properties.mapNode = this._element.closest(`div.map`);
				this.properties.popupNode = this._element.querySelector(`div.popup`);
				this.properties.arrowNode = this._element.querySelector(`div.arrow`);

				if ( this.properties.mapNode.id.includes(`map-contacts`) )
				{
					this.properties.popupNode.classList.add(`contacts`);
				}

				if ( this.properties.mapNode.id.includes(`complexes-list`) )
				{
					this.properties.popupNode.classList.add(`complexes-list`);
				}

				if ( this.properties.mapNode.id.includes(`map-chooser`) )
				{
					this.properties.popupNode.classList.add(`chooser`);
				}

				this.properties.mapHeight = this.properties.mapNode.offsetHeight;
				this.properties.arrowHeight = this.properties.arrowNode.offsetHeight;
				this.properties.pinHeight = this.getData().object.properties.size.height;
				this.properties.popupWidth = this.properties.popupNode.offsetWidth;
				this.properties.popupHeight = this.properties.popupNode.offsetHeight + this.properties.arrowHeight;
				this.properties.popupOffset = 8;
				this.properties.popupTopPosition = this.properties.popupOffset + this.properties.arrowHeight;
				this.properties.popupBottomPosition = ( this.properties.popupOffset + this.properties.pinHeight + this.properties.popupHeight ) * -1;
				this.properties.popupLeftPosition = this.properties.popupWidth / -2;
			},
			getShape: function () {
				if ( this._element )
				{
					const isPopupOverTopMap = this.properties.popupNode.getBoundingClientRect().top < this.properties.mapNode.getBoundingClientRect().top;
					const isPopupOverBottomMap = this.properties.popupNode.getBoundingClientRect().top + this.properties.popupHeight > this.properties.mapNode.getBoundingClientRect().top + this.properties.mapHeight;
					this._element.style.position = `absolute`;
					this._element.style.top = `${!isPopupOverBottomMap && isPopupOverTopMap ? this.properties.popupTopPosition : this.properties.popupBottomPosition}px`;
					this._element.style.left = `${this.properties.popupLeftPosition}px`;
					this.properties.arrowNode.classList.add(`top`);
					
					if ( !isPopupOverBottomMap && isPopupOverTopMap )
					{
						this.properties.arrowNode.classList.add(`top`);
						this.properties.arrowNode.classList.remove(`bottom`);
					} else
					{
						this.properties.arrowNode.classList.remove(`top`);
						this.properties.arrowNode.classList.add(`bottom`);
					}
				}
			},
		});
	
	return balloonLayout;
};
